var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAkart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 32,
    viewBox: "8 -2 24 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "43.786%",
    x2: "58.702%",
    y1: "23.653%",
    y2: "87.003%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "7.469%",
    stopColor: "#5C2483",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#5C2483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "69.664%",
    x2: "30.869%",
    y1: "83.587%",
    y2: "2.886%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "7.469%",
    stopColor: "#5C2483",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#5C2483"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M31.157 21.622s-.716 7.146-.859 8.388h2.394s.286-1.935.94-7.432c.124-.997.287-2.992.287-2.992l-2.762 2.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M24.652 3.237c3.069-.753 5.278.652 6.28 6.8.287 1.792.41 3.807.43 5.884.92-.733 1.82-1.446 2.66-2.117-.082-2.464-.369-4.826-.86-7.004C32.1 2.077 29.05.061 25.962.061c-.41 0-.84.04-1.31.122v3.054z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c2483",
    d: "m 25.961,0.04 c -3.58,0 -10.106,3.055 -16.694,10.2 -7.446,8.064 -9.247,14.396 -9.247,17.714 0,3.319 2.23,5.945 6.26,5.945 4.03,0 10.496,-2.524 20.11,-8.978 9.616,-6.454 18.904,-14.496 18.904,-14.496 L 43.289,5.845 C 41.223,7.493 32.139,16.187 20.029,23.964 8.388,31.415 4.685,30.194 4.194,29.237 3.764,28.423 2.905,25.572 7.61,17.999 12.316,10.425 19.66,5.07 23.404,3.625 c 0.92,-0.367 1.78,-0.57 2.578,-0.59 V 0.04 h -0.02 z",
    id: "path18"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkart);
export default __webpack_public_path__ + "static/media/akart.21dcbf7f0d737e52a14e933827ab72cd.svg";
export { ForwardRef as ReactComponent };